import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/doaapproval',
  component: () => import('@views/DOAApproval/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'doaapproval.index',
      component: () => import('@/components/DOAApproval/DOAApproval')
    }
  ]
}
